import { type ReactNode } from 'react';

import { ViewportFrame, ViewportPage } from './viewport-shell';

type BottomNavPageLayoutProps = {
  children: ReactNode;
  frameDataUi: string;
  overlay?: ReactNode;
  pageDataUi: string;
  stickyFooter: ReactNode;
};

export function BottomNavPageLayout({
  children,
  frameDataUi,
  overlay,
  pageDataUi,
  stickyFooter,
}: BottomNavPageLayoutProps) {
  return (
    <ViewportPage dataUi={pageDataUi}>
      <ViewportFrame dataUi={frameDataUi}>
        {children}
        {stickyFooter}
        {overlay}
      </ViewportFrame>
    </ViewportPage>
  );
}
